var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWebb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 444.6 440.6",
    style: {
      enableBackground: "new 0 0 444.6 440.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.6,26.4l-18.5,11.9l5.4-16c-22.4-6.9-64.8-22.4-126.8-22.4c-41.9,0-63.1,5.3-70.8,7l5.5,52L160,9.9 c-31.3,8.6-59.9,24.1-83.8,44.6l4.6,13.9l-12.6-6.7C43,85.6,23.5,115.4,11.9,148.9l18.3,12l-21.6-1.7c-0.9,3.3-1.8,6.5-2.6,9.9 c-3.9,16.4-6,33.4-6,51c0,8.5,1.1,16.8,2.9,25.1l10.4,4.5L6,256.8c6.5,21.4,17.1,42,25.5,62.2c0.4,0.9,0.8,1.9,1.1,2.8 c0.8,1.9,1.5,3.7,2.2,5.6c14.4,38,17.4,74.4-34.5,111.7c0,0,86.5-22,86.5-121.6l0.2-34.9v-17.4v-0.9c0-26.7,6.9-51.8,18.9-73.6 c19.5-35.4,52.5-62.4,92.3-73.6c13.2-3.7,27.2-5.7,41.7-5.7c30.2,0,60.9,8.8,87.9,27.7L435.2,62l9.4-6.7 C424,44.6,396.8,31.6,382.6,26.4z M376.7,207.5c-8.4-20.5-21.5-38.7-37.6-53.6c-12.7,6.8-31.4,16.7-50.4,26.8 c-36.9,19.6-75.4,40.1-75.4,40.1l50.9-36.6l44.9-32.4c-20.2-12.6-44-19.9-69.4-19.9l0,0c-22.5,0-43.8,5.7-62.4,15.8 c-29.7,16.1-52.7,43.2-63.3,75.8c-4.1,12.8-6.4,26.4-6.4,40.5l0,0v16.1v134.1h4c1.9,0,3.9-0.1,6.1-0.2c23.4-2.5,51.4-12.7,65.6-33.3 c-21.7-33.3-20.8-79.3-19.9-76.6c6.8,20.8,17,40.1,29.9,57.2c15.4,20.5,34.7,38,56.8,51.3c1,0.7,2,1.3,3,2 c26.1,16.6,57,26.2,90.1,26.2c1.1,0,2.2-0.1,3.3-0.1c1.6,0,3.3,0,4.9-0.1L337,379.7l0,0l-17.9-75.5l-33.9,0.1l-26.1-37.8 c60.1-20.4,81.4,25.4,81.4,25.4l7.2,29.6l28.8,10.1l-6.2-87.5l-65.9-3.6l-117.8,9l194.5-30C379.8,215.3,378.3,211.4,376.7,207.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWebb);
export default __webpack_public_path__ + "static/media/logo-webb.daae16c516ae777b22af5efd34966f51.svg";
export { ForwardRef as ReactComponent };